// src/redux/slice/evl/evl0104p_slice.ts
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import cloneDeep from "lodash/cloneDeep";
import type { IEvl0104pState, PopupMode, SelectOption } from "../../models/evl/evl0104p_model";

const initialState: IEvl0104pState = {
  mode: "NEW",
  hrEvlItmId: undefined,
  rowData: undefined,

  evlCdOptions: [],
  itmTypCdOptions: [],
  dtlTypCdOptions: [],

  loadingSeq: false,
};

export const Evl0104p_Slice = createSlice({
  name: "Evl0104p_Slice",
  initialState,
  reducers: {
    initState: (state) => {
      return { ...cloneDeep(initialState) };
    },

    setContext: (
      state,
      action: PayloadAction<{
        mode: PopupMode;
        hrEvlItmId?: string;
        rowData?: any;
      }>
    ) => {
      state.mode = action.payload.mode;
      state.hrEvlItmId = action.payload.hrEvlItmId;
      state.rowData = action.payload.rowData;
    },

    setOptions: (
      state,
      action: PayloadAction<{
        evlCdOptions?: SelectOption[];
        itmTypCdOptions?: SelectOption[];
        dtlTypCdOptions?: SelectOption[];
      }>
    ) => {
      if (action.payload.evlCdOptions) state.evlCdOptions = action.payload.evlCdOptions;
      if (action.payload.itmTypCdOptions) state.itmTypCdOptions = action.payload.itmTypCdOptions;
      if (action.payload.dtlTypCdOptions) state.dtlTypCdOptions = action.payload.dtlTypCdOptions;
    },

    setLoadingSeq: (state, action: PayloadAction<boolean>) => {
      state.loadingSeq = action.payload;
    },
  },
});

export default Evl0104p_Slice.reducer;
export const Evl0104pAction = Evl0104p_Slice.actions;
export const Evl0104pReducer = Evl0104p_Slice.reducer;
